export default {
  lineNumberColor: `#c5c8c6`,
  lineNumberBgColor: `#1d1f21`,
  backgroundColor: `#1d1f21`,
  textColor: `#c5c8c6`,
  substringColor: `#c5c8c6`,
  keywordColor: `#b294bb`,
  attributeColor: `#f0c674`,
  selectorAttributeColor: `#b294bb`,
  docTagColor: `#c5c8c6`,
  nameColor: `#cc6666`,
  builtInColor: `#de935f`,
  literalColor: `#de935f`,
  bulletColor: `#b5bd68`,
  codeColor: `#c5c8c6`,
  additionColor: `#b5bd68`,
  regexpColor: `#cc6666`,
  symbolColor: `#b5bd68`,
  variableColor: `#cc6666`,
  templateVariableColor: `#cc6666`,
  linkColor: `#de935f`,
  selectorClassColor: `#cc6666`,
  typeColor: `#de935f`,
  stringColor: `#b5bd68`,
  selectorIdColor: `#cc6666`,
  quoteColor: `#969896`,
  templateTagColor: `#c5c8c6`,
  deletionColor: `#cc6666`,
  titleColor: `#81a2be`,
  sectionColor: `#81a2be`,
  commentColor: `#969896`,
  metaKeywordColor: `#c5c8c6`,
  metaColor: `#de935f`,
  functionColor: `#c5c8c6`,
  numberColor: `#de935f`,
}
